import { FormItem, NumberInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.ValueRange}`;

export interface IValueRangeRuleComponentProps {}

export function ValueRangeRuleComponent(props: IValueRangeRuleComponentProps) {
  // const {} = props;
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Minimo"
        help="Il numero si considera incluso."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.max`}
        label="Massimo"
        help="Il numero si considera incluso."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
